import { useMutation, useQueryClient, UseMutationResult } from "@tanstack/react-query";
import axiosInstance from "./axiosInstanse";
import { enum_api_uri } from "../utils/enum";

interface DeleteRequest {
    idx: string;
}

interface DeleteResponse {
    statusCode: number;
    message: string;
    data: number[];
}

export const useDeleteAddress = (onSuccessCallback?: () => void): UseMutationResult<DeleteResponse, Error, DeleteRequest> => {
    const queryClient = useQueryClient();

    return useMutation<DeleteResponse, Error, DeleteRequest>({
        mutationFn: async (body: DeleteRequest) => {
            const res = await axiosInstance.put(enum_api_uri.delete_address, body);
            return res.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["usePostAddressBook"] });
            onSuccessCallback?.();
        },
    });
};
